// question-pack.service.ts

import { Injectable } from '@angular/core';
import {AIApps} from '../types/AIApps';
import { NotetakerCallsService } from './notetaker-calls.service';
import { IClientConfig } from '../types/client-config';
import { IQuestionPackCreate } from '../types/IQuestionManager';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class QuestionPackService {
  constructor(private noteTakerCallsService: NotetakerCallsService) {}

  updateClientConfigWithQuestionPack(
    clientConfig: IClientConfig,
    newPack: IQuestionPackCreate
  ): Observable<any> {
    const questionPackId = newPack.sortKey;
    let metaObj: any = {};

    try {
      metaObj = (clientConfig.meta as any)?.questionPacks ? clientConfig.meta : {};
    } catch (e) {
      console.warn('Failed to parse config meta JSON. Reinitializing.');
      metaObj = {};
    }

    const existingPacks = metaObj.questionPacks ?? [];
    if (!existingPacks.includes(questionPackId)) {
      existingPacks.push(questionPackId);
    }

    const corpRaw = newPack.corporationId;
    const corpIdNumber =
      (typeof corpRaw === 'string' && corpRaw.startsWith('bullhorn-'))
        ? corpRaw.replace(/^bullhorn-/, '')
        : String(corpRaw);

    metaObj.questionPacks = existingPacks;

    const minimalConfigPayload = {
      app: AIApps.NOTETAKER,
      corporationId: corpIdNumber,
      corpId: clientConfig.corpId || '',
      namespace: newPack.namespace,
      meta: JSON.stringify(metaObj),
      timestamp: Date.now()
    };

    return this.noteTakerCallsService.saveQuestionPackToConfig(minimalConfigPayload);
  }
}
